import React from 'react';
import PopoutWindow from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/PopoutWindow";
import {useViewerStore} from "../../../../store/store";
import TotalSystemEfficiency from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/TotalSystemEfficiency";
import RoofInformationTable from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/RoofInformationTable";
import IrradienceCharts from '../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/IrradienceCharts';
import MonthlyProductionEstimate from '../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/MonthlyProductionEstimate';
import ModulesInformationTable from '../../../../components/Layout-Components/Editor-Layout/Popout-Window/Production-Calculation-Popout/Production-Calculation-Popout-Tabs/ModulesInformationTable';
import { Pane } from '../../../../@types/types';
import type { IrradiancePopupProps } from './IrradiancePopup.types';
import {useCurrentUser} from "../../../../contexts/UserContext";

const setModuleMultiplierLabelsVisible = (visible: boolean) => {
    const sceneViewer = useViewerStore.getState().sceneViewer;
    if (!sceneViewer) return;
    useViewerStore.setState({ isModuleMultiplierLabelVisible: visible });
    sceneViewer.toggleModuleMultiplierLabel(visible);
};

const enableModuleLabels = () => setModuleMultiplierLabelsVisible(true);
const disableModuleLabels = () => setModuleMultiplierLabelsVisible(false);

const IrradiancePopup: React.FC<IrradiancePopupProps> = ({ isOpenByDefault = true }) => {
    const {hasCapability} = useCurrentUser();
    const canShowModuleMultipliers = hasCapability('Modules_Multipliers');

    const panes: Pane[] = [
        {
            tab: 'Total System Efficiency',
            key: 'totalSystemEfficiencyTab',
            content: <TotalSystemEfficiency popoutVersion={true}/>,
            onPaneChangeCallback: disableModuleLabels,
        },
        {
            tab: 'Roof Efficiency Table',
            key: 'roofEfficiencyTab',
            content: <RoofInformationTable />,
            onPaneChangeCallback: () => {
                disableModuleLabels();
                useViewerStore.setState({pitchDisplayMode: "Pitch Override"});
            },
            onMinMaxPopoutCallback: () => {
                useViewerStore.setState({pitchDisplayMode: "Pitch Override"});
            }
        },
        ...(canShowModuleMultipliers ? [{
            tab: 'Modules',
            key: 'modulesTab',
            content: <ModulesInformationTable />,
            onPaneChangeCallback: enableModuleLabels,
            onMinMaxPopoutCallback: enableModuleLabels,
        } as Pane] : []),
        {
            tab: 'Irradiance',
            key: 'irradianceTab',
            content: <IrradienceCharts/>,
            onPaneChangeCallback: disableModuleLabels,
        },
        {
            tab: 'Monthly Production Estimate',
            key: 'monthlyProductionEstimate',
            content: <MonthlyProductionEstimate />,
            onPaneChangeCallback: disableModuleLabels,
        }
    ];

    return (
        <PopoutWindow
            tabTitle='Production'
            tooltip={"Show System Information"}
            panes={panes}
            isOpenByDefault={isOpenByDefault}
        />
    );
}

export default IrradiancePopup;
